<script>

    import {bytesToHuman} from "../Utils";
    import { t } from "../../../i18n";

    export let name;
    export let files = 0;
    export let size = 0;

    $: descriptions = [
        files && $t('files.count', {n: Number(files) || 0}),
        size && bytesToHuman(size),
    ];
</script>

<div class="col-12 col-md-6 col-xl-3">
    <div class="card border shadow-none mb-1 app-file-info">
        <div class="card-content">
            <div class="card-body px-75 py-50">
                <div class="app-file-folder-content d-flex align-items-center">
                    <div class="app-file-folder-logo mr-75">
                        <i class="bx bx-folder font-medium-4"></i>
                    </div>
                    <div class="app-file-folder-details">
                        <div class="app-file-folder-name font-size-small font-weight-bold">{name||''}</div>
                        <div class="app-file-folder-size font-size-small text-muted">{descriptions.filter(n=>n).join(', ')}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>